var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoChange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2624_7431)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.26085 14.116H3.13042C1.83375 14.116 0.782593 15.1549 0.782593 16.4365V31.9061C0.782593 33.1876 1.83375 34.2265 3.13042 34.2265H6.26085C7.55752 34.2265 8.60868 33.1876 8.60868 31.9061V16.4365C8.60868 15.1549 7.55752 14.116 6.26085 14.116Z",
    stroke: "#1A39DA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4782 17.9834C33.9886 17.9834 35.2173 19.2055 35.2173 20.6906C35.2173 22.1834 33.9808 23.3978 32.4782 23.3978H28.5339H31.6956C33.1982 23.3978 34.4347 24.6122 34.4347 26.105C34.4347 27.5978 33.1982 28.8122 31.6956 28.8122H27.7826H30.913C32.4156 28.8122 33.6521 30.0265 33.6521 31.5194C33.6521 33.0122 32.4156 34.2265 30.913 34.2265H16.4347C12.1147 34.2265 8.60864 30.7613 8.60864 26.4917V16.4365C10.7452 16.4365 15.2139 11.9812 17.2486 5.70057C17.8434 3.86742 17.2799 0.773499 19.4243 0.773499C20.1052 0.773499 21.8269 1.09836 22.8599 3.33372C25.3017 8.60886 21.913 12.5691 21.913 12.5691H32.4782C33.9808 12.5691 35.2173 13.7834 35.2173 15.2763C35.2173 16.5834 34.2704 17.6741 33.026 17.9293C33.0182 17.9293 32.6504 17.9834 32.4782 17.9834ZM32.4782 17.9834C32.5956 17.9834 29.1678 17.9989 29.2773 17.9834H32.4782Z",
    stroke: "#1A39DA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2624_7431"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 35,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoChange);
export default __webpack_public_path__ + "static/media/no-change.3e37b62e5f6be493f8e4b2d75b6df73d.svg";
export { ForwardRef as ReactComponent };